import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import LeiService from '../../../../services/leis-auth';
import { Link } from 'react-router-dom';
//import Moment from 'moment';



/*async function getLeis() {
    let resposta = await fetch('http://localhost:3000/api/leis.json')
    let nvlei = await resposta.json()
    return nvlei
}*/



const Lei = () => {
    const [numLei, setNumLei] = useState("");
    const [letra, setLetra] = useState("");
    const [dataLei, setDataLei] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [ano, setAno] = useState("");
    const [categoria, setCategoria] = useState("");
    const [ementa, setEmenta] = useState("");
    const [jornal, setJornal] = useState("");
    const [error, setError] = useState([]);
    const [arquivo, setArquivo] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    /*const [novasLeis, setNovas] = useState([]);

    useEffect(() => {
         getLeis().then(data => {
             setNovas(data['leis'])
         })
     }, [])
 
     const enfiatudo = async () => {
         novasLeis.map(async (item) => {
             const lei = await LeiService.cadastro(
                 {
                     cod_lei: parseInt(item.cod_lei),
                     numero: item.num_lei,
                     letra: item.letra,
                     data_lei: item.data_lei,
                     data_publicacao: item.data_p,
                     ano: item.ano,
                     categoria: item.categoria,
                     ementa: item.ementa,
                     jornal: item.jornal,
                     arquivo: item.link_lei
                 }
             )
             })}*/
            

    const handleUpload = (e) => setArquivo(e.target.files[0]);


    const montaForm = async () => {
        const lei = new FormData();
        lei.append("numero", numLei)
        lei.append("letra", letra)
        lei.append("data_lei", dataLei)
        lei.append("data_publicacao", dataPub)
        lei.append("ano", ano)
        lei.append("categoria", categoria)
        lei.append("ementa", ementa)
        lei.append("jornal", jornal);
        lei.append("arquivo", arquivo);
        return lei
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lei = await LeiService.cadastro(dados)
            setSucesso(true)
            setError(false)
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNumLei("")
        setLetra("")
        setDataLei("")
        setDataPub("")
        setAno("")
        setCategoria("")
        setEmenta("")
        setJornal("")
        setArquivo("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                {/*<Button onClick={enfiatudo}>Importar Leis</Button>*/}
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="NumLei">
                                <FloatingLabel
                                    label="Número da Lei"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="num_lei"
                                        value={numLei}
                                        onChange={e => setNumLei(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Letra">
                                <FloatingLabel
                                    label="Letra da Lei"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Letra"
                                        name="letra"
                                        onChange={e => setLetra(e.target.value)}
                                    >
                                        <option>NENHUMA</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataLei">
                                <FloatingLabel
                                    label="Data da Lei"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data_lei"
                                        value={dataLei}
                                        onChange={e => setDataLei(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataPub">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataPub"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row xs={1} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                        <option value="2002">2002</option>
                                        <option value="2001">2001</option>
                                        <option value="2000">2000</option>
                                        <option value="1999">1999</option>
                                        <option value="1998">1998</option>
                                        <option value="1997">1997</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Lei Municipal">Lei Municipal</option>
                                        <option value="Lei Tributária">Lei Tributária</option>
                                        <option value="Lei Orçamentária">Lei Orçamentária</option>
                                        <option value="Lei de Transparência">Lei de Transparência</option>
                                        <option value="Lei Orçamentária Anual - LOA">Lei Orçamentária Anual - LOA</option>
                                        <option value="Lei Orçamentária Plurianual - PPA">Lei Orçamentária Plurianual - PPA</option>
                                        <option value="Lei de Diretrizes Orçamentárias - LDO">Lei de Diretrizes Orçamentárias - LDO</option>
                                        <option value="Decreto">Decretos</option>
                                        <option value="Portaria">Portarias</option>
                                        <option value="Indicação">Indicações</option>
                                        <option value="Lei Ordinária">Lei Ordinária</option>
                                        <option value="Lei Complementar">Lei Complementar</option>
                                        <option value="Lei de Vigilância Sanitária">Lei de Vigilância Sanitária</option>
                                        <option value="Resolução">Resoluções</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Jornal">
                                <FloatingLabel
                                    label="Jornal"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Jornal"
                                        name="jornal"
                                        onChange={e => setJornal(e.target.value)}
                                    >
                                        <option value="">Nenhum</option>
                                        <option value="O Sol">O Sol</option>
                                        <option value="Manchetes">Manchetes</option>
                                        <option value="O Fluminense">O Fluminense</option>
                                        <option value="O Centro Norte">O Centro Norte</option>
                                        <option value="O Momento">O Momento</option>
                                        <option value="O Macuco">O Macuco</option>
                                        <option value="Tribuna da Serra">Tribuna da Serra</option>
                                        <option value="da Região">da Região</option>
                                        <option value="Gazeta de Cordeiro">Gazeta de Cordeiro</option>
                                        <option value="Diário Oficial de Macuco">Diário Oficial de Macuco</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row xs={1} lg={2}>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="ementa">
                                <FloatingLabel
                                    label="Ementa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="textarea"
                                        name="ementa"
                                        value={ementa}
                                        onChange={e => setEmenta(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="arquivo">
                                <Form.Label>Arquivo da Lei</Form.Label>
                                <Form.Control
                                    required
                                    type="file"
                                    name="arquivo"
                                    onChange={handleUpload}
                                    accept="application/pdf"

                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/leis'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Lei cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br/><br/>
                <Link to={'/restrito/leis/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Leis
                    </Button>
                </Link>
                <br/><br/>
                <Link to={'/restrito/leis'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Lei;